import auth0 from "auth0-js";

import config from "../config/config";

//import { isEmpty } from '../helpers';

export default class Auth {
    auth0 = new auth0.WebAuth({
        domain: config.auth.domain,
        audience: config.auth.apiUrl,
        //ui_locales: "fr-CA fr en",
        clientID: config.auth.clientID,
        redirectUri: config.auth.redirectUri, // where to redirect users to after authentication
        responseType: "token id_token", // <-- we need this after authentication
        scope: "openid profile email access:portal"
    });
    accessToken; // credential that can be used by an application to access an API.
    idToken; // jwt token that contains user profile attributes represented in form of claims. Consumed by app and used to get user info like user name, email, etc.
    expiresAt;
    profile;
    timerID;
    syncFunc; // function for synchronizing state with the auth provider 

    constructor() {

        this.monitorSession = this.monitorSession.bind(this);


        this.getProfile = this.getProfile.bind(this);
        this.handleAuthentication = this.handleAuthentication.bind(this);
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.login = this.login.bind(this);
        this.logout = this.logout.bind(this);
        this.setSession = this.setSession.bind(this);
        this.renewSession = this.renewSession.bind(this);
    }

    // monitor the session as long as the user is logged in
    // when less than 5 minutes until the session expires, call a callback function
    monitorSession(cb) {
        // check every minute if we're 5 minutes till the expiry date
        this.timerID = window.setInterval(() => {
            const expiresAt = new Date(this.expiresAt);
            const now = new Date();

            // get number of minutes till expiry
            const difference = (expiresAt - now) / 1000 / 60;

            // get difference in minutes
            if (difference <= 5) {
                // raise a flag that it's about to expiry
                if (cb) { cb(); }
            }

        }, 60000);
    }

    renewSession() {

        return new Promise((resolve, reject) => {
            this.auth0.checkSession({
                //audience: 'https://example.com/api/v2',
                //scope: 'read:something write:otherthing'
                audience: config.auth.apiUrl,
                scope: "openid profile email access:portal"

            }, (err, authResult) => {

                if (authResult && authResult.accessToken && authResult.idToken) {
                    this.setSession(authResult);
                    resolve();

                } else if (err) {
                    // Could not get a new token (timeout: Timeout during executing web_message communication).
                    alert(
                        `Could not get a new token (${err.error}: ${
                        err.error_description
                        }).`
                    );

                    reject(err.error_description)
                }
            });
        })


        // return this.auth0.checkSession({
        //     //audience: 'https://example.com/api/v2',
        //     //scope: 'read:something write:otherthing'
        //     audience: config.auth.apiUrl,
        //     scope: "openid profile email access:portal"

        // }, (err, authResult) => {

        //     if (authResult && authResult.accessToken && authResult.idToken) {
        //         this.setSession(authResult);
        //     } else if (err) {


        //         // Could not get a new token (timeout: Timeout during executing web_message communication).
        //         alert(
        //             `Could not get a new token (${err.error}: ${
        //             err.error_description
        //             }).`
        //         );
        //     }
        // });
    }

    // get profile of logged in user
    getProfile() {

        return this.profile;
    }

    // This function looks for the result of the authentication process in the URL hash. Then, the function processes the result with the parseHash method from auth0-js.
    handleAuthentication() {
        return new Promise((resolve, reject) => {

            this.auth0.parseHash((err, authResult) => {
                if (err) return reject(err);

                if (!authResult || !authResult.idToken) {
                    return reject(err);
                }
                this.setSession(authResult);
                resolve();
            });
        });
    }

    // isAuthenticated: This function checks whether the expiry time for the user's ID token has passed.
    isAuthenticated() {
        return new Date().getTime() < this.expiresAt;
    }

    // define what email address you want to prepopulate the Auth0 lock screen with
    login(defaultEmail = '') {

        this.auth0.authorize({
            //ui_locales: "fr-CA fr en",
            prompt: "login",
            email: defaultEmail
        });
    }

    logout() {
        // clear id token and expiration
        this.idToken = null;
        this.expiresAt = null;
        this.accessToken = null;
        this.profile = null;

        // if (this.syncFunc) {
        //     this.syncFunc(this);
        // }

        // cut out the session monitoring
        window.clearInterval(this.timerID);

        this.auth0.logout({
            returnTo: config.auth.logoutRedirectUri,
            clientID: config.auth.clientID
        });
    }

    setSession(authResult) {


        this.accessToken = authResult.accessToken;
        this.idToken = authResult.idToken;
        this.profile = authResult.idTokenPayload;
        // set the time that the id token will expire at
        this.expiresAt = authResult.expiresIn * 1000 + new Date().getTime();

        // push the values upward
        if (this.syncFunc) {
            this.syncFunc(this);
        }


    }

}



// WEBPACK FOOTER //
// ./src/lib/Auth.js